import { render, staticRenderFns } from "./WaitingTable.vue?vue&type=template&id=52d3f72c&scoped=true&"
import script from "./WaitingTable.vue?vue&type=script&lang=js&"
export * from "./WaitingTable.vue?vue&type=script&lang=js&"
import style0 from "./WaitingTable.vue?vue&type=style&index=0&id=52d3f72c&lang=scss&scoped=true&"
import style1 from "./WaitingTable.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./WaitingTable.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d3f72c",
  null
  
)

export default component.exports